"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CORE
const react_1 = __importStar(require("react"));
const am4core = __importStar(require("@amcharts/amcharts4/core"));
const am4charts = __importStar(require("@amcharts/amcharts4/charts"));
const Link_1 = __importDefault(require("@mui/material/Link"));
// MUI
const styles_1 = require("@mui/material/styles");
const mui_1 = require("tss-react/mui");
// COMPONENTS
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const QAmountField_1 = __importDefault(require("components/QAmountField"));
const Breadcrumbs_1 = __importDefault(require("containers/NewReports/components/Breadcrumbs"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const useStyles = (0, mui_1.makeStyles)()((theme) => ({
    breadcrumbsContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    breadcrumb: {
        // textTransform: 'capitalize',
        color: theme.palette.text.secondary,
        '&:hover': {
            cursor: 'pointer',
            textDecoration: 'underline',
        },
    },
    centerSpacer: {
        width: 40,
    },
    chartDiv: {
        width: 'auto',
        minWidth: 300,
        height: 300,
    },
    chartDivDashboard: {
        width: 'auto',
        minWidth: 130,
        maxWidth: 300,
        height: 130,
        marginRight: 'auto',
        marginLeft: 'auto',
    },
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    legendContainer: {
        minWidth: 350,
        minHeight: 216,
        display: 'grid',
        gridTemplateRows: '1fr 1fr 1fr',
        gridTemplateColumns: '1fr 1fr 1fr',
        '&.dashboard': {
            minHeight: 150,
        },
    },
    legendItem: {
        all: 'unset',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        padding: '4px 8px 4px 0px',
        fontSize: 18,
        cursor: 'pointer',
        maxHeight: 72,
        minWidth: 135,
        maxWidth: 175,
        boxSizing: 'border-box',
    },
    legendColor: {
        minWidth: 20,
        width: 20,
        height: 20,
        borderRadius: '50%',
        marginRight: 8,
        marginTop: 2,
    },
    legendRight: {
        // textTransform: 'capitalize',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: 10,
        overflow: 'hidden',
    },
    legendGroup: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        minWidth: 0,
        maxWidth: '100%',
    },
    legendRoot: {
        width: '100%',
        margin: 'auto',
    },
    root: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    uncategoriedLink: {
        display: 'flex',
        alignItems: 'center',
        margin: '0 0 8px 35px',
    },
    uncategoriedLinkIconSpacing: {
        paddingRight: 5,
    },
}));
const ReportsPieChart = (0, react_1.forwardRef)(({ data, height, orderedFields, onSliceClick, forDashboard, capLegend, sliceExclusions, uncategorizedTransactionsCount = 0, showUncategorizedTransactionsLink = false, }, ref) => {
    const chart = (0, react_1.useRef)(null);
    const theme = (0, styles_1.useTheme)();
    const { classes, cx } = useStyles();
    const colors = (0, react_1.useMemo)(() => theme.palette.data.sequence1.map((color) => am4core.color(color)), [theme]);
    const initChart = (0, react_1.useCallback)(() => {
        // am4core.useTheme(am4themes_animated);
        am4core.options.autoDispose = true;
        const tempChart = am4core.create('pie-chart-div', am4charts.PieChart);
        const series = tempChart.series.push(new am4charts.PieSeries());
        series.name = 'groups';
        series.dataFields.category = 'category';
        series.dataFields.value = 'total';
        // series.sequencedInterpolation = true;
        series.labels.template.disabled = true;
        series.ticks.template.disabled = true;
        series.alignLabels = true;
        series.slices.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
        tempChart.innerRadius = am4core.percent(35);
        const shadow = series.slices.template.filters.push(new am4core.DropShadowFilter());
        shadow.opacity = 0;
        const hoverState = series.slices.template.states.getKey('hover');
        const defaultState = series.slices.template.states.getKey('default');
        if (hoverState && defaultState) {
            hoverState.properties.zIndex = 1001;
            defaultState.properties.zIndex = 1000;
            const hoverShadow = hoverState.filters.push(new am4core.DropShadowFilter());
            hoverShadow.opacity = 0.4;
            hoverShadow.blur = 5;
        }
        series.slices.template.adapter.add('fill', (_, target) => colors[orderedFields.indexOf(target === null || target === void 0 ? void 0 : target.dataItem.category)]);
        series.slices.template.events.on('hit', (e) => {
            onSliceClick === null || onSliceClick === void 0 ? void 0 : onSliceClick(e.target.dataItem.dataContext);
        });
        if (series === null || series === void 0 ? void 0 : series.tooltip) {
            series.tooltip.background.strokeWidth = 0;
            series.tooltip.background.cornerRadius = theme.shape.borderRadius;
            series.tooltip.background.pointerLength = 0;
            series.tooltip.background.valign = 'middle';
            series.tooltip.zIndex = Infinity;
            series.tooltip.getFillFromObject = false;
            series.tooltip.background.fill = am4core.color(theme.palette.background.paper);
            series.tooltip.background.fillOpacity = 0.95;
            series.tooltip.label.padding(0, 0, 0, 0);
            series.tooltip.label.maxWidth = 250;
            series.tooltip.label.wrap = true;
        }
        series.slices.template.tooltipHTML = `<div id="reports-pie-chart-tooltip" style="color: ${theme.palette.text.primary};border-radius: ${theme.shape.borderRadius}px;padding: ${theme.shape.padding[2]}px;">
      <div style="display:flex;gap: 10px;flex-wrap:wrap;white-space: initial;width:auto;">
        <div style="background: {fill};width: 12px;height: 12px;border-radius: 50%;margin-top: 6px;" ></div>
        <p style="margin: 0px;padding: 0px;flex:1;" id="reports-pie-tooltip-category" >{category}</p>
      </div>
      <p style="margin: 0px;padding: 0px;" id="reports-pie-tooltip-amount" >\${total}</p>
    </div>`;
        tempChart.numberFormatter.numberFormat = '#,###.00';
        return tempChart;
    }, [orderedFields, colors, onSliceClick, theme]);
    // create the chart
    (0, react_1.useLayoutEffect)(() => {
        const constructedChart = initChart();
        chart.current = constructedChart;
        constructedChart.data = data === null || data === void 0 ? void 0 : data.filter((item) => item.total > 0 && !(sliceExclusions === null || sliceExclusions === void 0 ? void 0 : sliceExclusions.includes(item.category))); // filter out negative values cus it's  pie chart
        // eslint-disable-next-line consistent-return
        return () => {
            if (constructedChart) {
                constructedChart.dispose();
            }
        };
    }, [data, orderedFields, initChart, sliceExclusions]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        getGraphImage() {
            var _a, _b;
            return (_b = (_a = chart.current) === null || _a === void 0 ? void 0 : _a.exporting) === null || _b === void 0 ? void 0 : _b.getImage('png', { quality: 1, scale: 3 });
        },
    }));
    const handleLegendOver = (0, react_1.useCallback)((field) => (_e) => {
        var _a, _b;
        const mainSeries = ((_b = (_a = chart === null || chart === void 0 ? void 0 : chart.current) === null || _a === void 0 ? void 0 : _a.series) === null || _b === void 0 ? void 0 : _b.getIndex(0)) || null;
        if (!mainSeries)
            return;
        mainSeries.slices.each((paramSlice) => {
            const slice = paramSlice;
            slice.isHover = slice.dataItem.category === field;
        });
    }, []);
    const legend = (0, react_1.useMemo)(() => (<div className={classes.legendRoot}>
      {!forDashboard && <Breadcrumbs_1.default />}
      <div id="pieLegends" className={cx(classes.legendContainer, forDashboard ? 'dashboard' : '')}>
        {(capLegend ? orderedFields.slice(0, capLegend) : orderedFields).map((field, index) => {
            var _a;
            return (<button onMouseOut={handleLegendOver(null)} onBlur={handleLegendOver(null)} onClick={(e) => {
                    e.stopPropagation();
                    onSliceClick(data.find((item) => item.category === field));
                }} onMouseOver={handleLegendOver(field)} onFocus={handleLegendOver(field)} key={`pie-chart-legend-item-${field}`} className={classes.legendItem} type="button">
            <div className={classes.legendColor} id="legendColorButtons" style={{ backgroundColor: (sliceExclusions === null || sliceExclusions === void 0 ? void 0 : sliceExclusions.includes(field)) ? theme.palette.text.disabled : colors[index] }}/>
            <div className={classes.legendRight} id="legendTextWrapper">
              <QTypography_1.default className={classes.legendGroup} variant={'body1'} id={'reports_pie_chart_legend_category'}>{field}</QTypography_1.default>
              <QAmountField_1.default expectedSign="positive" style={{ alignSelf: 'center' }} variant={'body1'} id={'reports_pie_chart_legend_amount'} value={((_a = data === null || data === void 0 ? void 0 : data.find((item) => item.category === field)) === null || _a === void 0 ? void 0 : _a.total) || 0}/>
            </div>
          </button>);
        })}
      </div>
    </div>), [classes, forDashboard, capLegend, orderedFields, handleLegendOver, sliceExclusions, theme.palette.text.disabled, colors, data, onSliceClick, cx]);
    const rootStyle = (0, react_1.useMemo)(() => ({
        height: height || 'auto',
        flexDirection: forDashboard ? 'column' : 'row',
    }), [height, forDashboard]);
    const handleCategorizeUncategorized = (e) => {
        e.stopPropagation();
        onSliceClick(data.find((item) => item.category === 'Uncategorized'));
    };
    const renderUncategorizedLink = () => (<QTip_1.default title="Quicken recommends you to categorize all your transactions so you know exactly
      where your money is spent. This will also give a correct picture in your budgets and reports" placement="right-start" popperProps={{
            modifiers: {
                offset: {
                    enabled: true,
                    offset: '-40,0',
                },
                flip: {
                    enabled: false,
                },
            },
        }}>
      <Link_1.default component="button" variant="caption" underline="hover" onClick={handleCategorizeUncategorized}>
        <div className={classes.uncategoriedLink}>
          <i className={cx('material-icons', classes.uncategoriedLinkIconSpacing)}>info</i>
          <span className={classes.categorizeBtn}>
            {uncategorizedTransactionsCount} Uncategorized transaction{uncategorizedTransactionsCount > 1 ? 's' : ''}
          </span>
        </div>
      </Link_1.default>
    </QTip_1.default>);
    return (<>
      <RendersCount_1.default id="newReportsPieChart"/>
      <div className={classes.root} style={rootStyle}>
        <div className={forDashboard ? classes.chartDivDashboard : classes.chartDiv} id={'pie-chart-div'}/>
        <div className={classes.centerSpacer}/>
        {legend}
      </div>
      {showUncategorizedTransactionsLink && renderUncategorizedLink()}
    </>);
});
exports.default = ReportsPieChart;
